module.exports = __webpack_public_path__ + "img/NS-1440.bb99a0c8.jpg";